<script setup>
import Header from "@/components/Header.vue";
import HeroSection from "@/components/HeroSection.vue";
import ValuePropositions from "@/components/ValuePropositions.vue";
import DashboardPreview from "@/components/DashboardPreview.vue";
import FeaturesGrid from "@/components/FeaturesGrid.vue";
import PricingSection from "@/components/PricingSection.vue";
import FAQSection from "@/components/FAQSection.vue";
import ContactSection from "@/components/ContactSection.vue";
import Footer from "@/components/Footer.vue";
</script>

<template>
  <main class="min-h-screen bg-background">
    <Header />
    <HeroSection />
    <ValuePropositions />
    <DashboardPreview />
    <FeaturesGrid />
    <PricingSection />
    <FAQSection />
    <ContactSection />
    <Footer />
  </main>
</template>
